import imageProcessor from 'mand-mobile/lib/image-reader/image-processor'
import { getImageSize } from '@/utils/get-image-size'
// 压缩证件图片宽高以及size
export async function compressionImage (file, { MAX_SIZE = 2097152, MAX_LENGTH_OF_SIDE = 3900 } = {}) {
  const { dataUrl } = file
  const { width, height } = await getImageSize(dataUrl)

  const imageConfig = {
    quality: 0.6,
    dataUrl
  }

  // 原图尺寸符合要求
  if (width > MAX_LENGTH_OF_SIDE || height > MAX_LENGTH_OF_SIDE) {
    if (width >= height) {
      imageConfig.width = MAX_LENGTH_OF_SIDE
    } else {
      imageConfig.height = MAX_LENGTH_OF_SIDE
    }
    // 不需要压缩
  } else if (file.blob.size < MAX_SIZE) {
    return file
  }

  const result = await imageProcessor(imageConfig)

  // 递归压缩逻辑，超过尺寸要求继续压缩
  if (result.blob.size > MAX_SIZE) return compressionImage(result, { MAX_SIZE, MAX_LENGTH_OF_SIDE })

  return result
}
